// extracted by mini-css-extract-plugin
module.exports = {"FaqPillButton":"FaqPillButton_FaqPillButton__ZktWg","--selected":"FaqPillButton__--selected__kzwuC"};